//Created by wangshuyi on 07/03/2018.

'use strict';
import axios from 'axios'
import dolphinCoreConfig from '../config';

const ajax = function (_params) {
    let params = Object.assign({}, dolphinCoreConfig.ajax, _params);

    //是否添加前缀，不加条件：1. 参数要求，2. 已添加过系统前缀，3. 以http://或https://开头
    if(!(params.forceUrl || new RegExp(`^${this.$Dolphin.path.apiPath}|https?://`).test(params.url))){
        params.url = this.$Dolphin.path.apiPath + params.url;
    }

    //处理路径参数
    if(params.pathData){
        for (let key in params.pathData) {
            params.url = params.url.replace(`{${key}}`, params.pathData[key]);
        }
    }
    params.url.replace(/\{[\d|\w]*\}/g, '');

    //获取处理token
    const token = this.$store ? this.$store.state.token : '';
    const locale = this.$i18n ? this.$i18n.locale : 'zh';
    let defaultHeaders = {token: params.encodeToken(token)};
    if(params.i18nHeader){
        defaultHeaders.locale = locale;
    }
    params.headers = Object.assign(defaultHeaders, params.headers);

    //显示遮罩层
    let showLoadingTimeout;
    if(params.loading && this.$store){
        if(params.loadingTimeout){
            showLoadingTimeout = setTimeout(() => this.$store.commit('setLoading', true), params.loadingTimeout);
        }else{
            this.$store.commit('setLoading', true);
        }
    }

    return axios.request(params).then(reData => {
        let result = reData.data;
        //业务校验 是否请求成功，默认为Boolean(result.success);
        if(params.checkResult(result)){
            return result;
        }else{
            throw result;
        }
    }).catch(e => {
        //失败时，是否直接弹出提示
        if(params.showMessage){
            let message = e.message;
            if(this.$i18n && typeof this.$t === 'function'){
                let i18nMessage = this.$t(`systemMessage.${e.errorCode}`, e.messageInfo);
                if(i18nMessage !== `systemMessage.${e.errorCode}`){
                    message = i18nMessage;
                }
            }

            let title = '系统提示';
            if(this.$i18n && typeof this.$t === 'function'){
                let titleMessage = this.$t(`systemMessage.1`);
                if(titleMessage !== `systemMessage.1`){
                    title = titleMessage;
                }
            }

            if(window.$DolAntPage){ // 基于AntDesign框架
                window.$DolAntPage.$error({ title: title, content: message });
            } else if (window.$DolVantPage){
                window.$DolVantPage.$dialog.alert({ title: title, message: message });
            } else {
                alert(message);
            }
        }
        throw e;
    }).finally(() => {
        if(params.loading && this.$store){
            if(showLoadingTimeout){
                clearTimeout(showLoadingTimeout);
            }
            this.$store.commit('setLoading', false);
        }
    });
};

export default ajax;
